import React, { useRef, useContext } from 'react';
import { useFrame } from 'react-three-fiber';

import { ConfigContext } from './config';
import { ShapeContext } from './shapes';

const Scene = () => {
  const group = useRef();
  const { useConfig } = useContext(ConfigContext);
  const { shapes } = useContext(ShapeContext);

  const enableAutoRotation = useConfig('enableAutoRotation');
  const enableWireframes = useConfig('enableWireframes');

  useFrame(() => {
    if (enableAutoRotation) {
      group.current.rotation.x = group.current.rotation.y += 0.01;
    }
  });

  const material = <meshNormalMaterial wireframe={enableWireframes} />;

  return (
    <group position={[0, 0, 0]} ref={group}>
      {shapes.map(({ Component, position, rotation, args }, i) => (
        <Component position={position} rotation={rotation} args={args} key={i}>
          {material}
        </Component>
      ))}
    </group>
  );
};

export default Scene;
